import { filterFileAttachments, filterUploadingAttachments } from '@/components/Attachment/utils'
import { Button, type ButtonProps } from '@mantine/core'
import { Attachment } from '@/utils/fetchers/attachment'
import { isEmpty } from 'lodash-es'
import { useWatch } from 'react-hook-form'
import type { PostFormValue } from './schemas'

export interface SubmitButtonProps extends ButtonProps {}

export default function SubmitButton({ ...props }: SubmitButtonProps) {
	const content = useWatch<PostFormValue, 'content'>({
		name: 'content',
	})
	const attachmentIds = useWatch<PostFormValue, 'attachment.ids'>({
		name: 'attachment.ids',
	})
	const attachmentMap = useWatch<PostFormValue, 'attachment.map'>({
		name: 'attachment.map',
	})
	const attachments = attachmentIds.map((id) => attachmentMap[id]).filter(Boolean) as Attachment[]
	const uploadingAttachments = filterUploadingAttachments(filterFileAttachments(attachments))
	const hasUploadingAttachments = uploadingAttachments.length > 0

	const isDisabled = (isEmpty(content) && attachments.length === 0) || hasUploadingAttachments

	return (
		<Button disabled={isDisabled} size="sm" type="submit" {...props}>
			发送
		</Button>
	)
}
